"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultCall = void 0;
var defaultCall = {
  error: false,
  fetching: false,
  success: false
};
exports.defaultCall = defaultCall;
var _default = {
  calls: {}
};
exports.default = _default;